import { Link } from 'react-router-dom';

export default function TakeawaysKeyMotivator() {
  return (
    <>
    </>
  );
}
